import { faGift } from '@fortawesome/free-solid-svg-icons';
import OffersScreen from './Offer';

export type OfferRoutes = Record<
    (
        `w/${string}/offers` |
        `w/${string}/offers/${string}`
    ),
    RouteProps
>

const routes: OfferRoutes = {
    'w/:wallet_id/offers': {
        path: 'w/:wallet_id/offers',
        title: 'Offers',
        component: OffersScreen,
        mainPage: true,
        auth: true,
        exact: true,
        showTab: true,
        icon: faGift,
    },
    'w/:wallet_id/offers/:id': {
        path: 'w/:wallet_id/offers/:id',
        title: 'Offers',
        component: OffersScreen,
        auth: true,
        exact: true,
        icon: faGift,
    },
};

export default routes;
